<template>
  <div class="paragraph">
    <div class="paragraph__main">
      <div class="paragraph__list">
      <!-- FOREACH: -->
        <!-- DEBUT ITERATION 1 -->
        <div class="paragraph__list-item">
          <div class="paragraph-item">
            <div class="paragraph-item__content">
              <!-- IF ITEM.TITLE -->
              <h2 class="paragraph-item__title">Pourquoi mesurer la maturité numérique de votre entreprise ?</h2>
              <div class="paragraph-item__text">
                <!-- ITEM.TEXT -->
                <p><strong>L’un des objectifs majeurs de la stratégie numérique
                Digital Wallonia est de soutenir et accélérer la transformation
                numérique des entreprises wallonnes.</strong> Quels que soient leur
                secteur d’activité, leur taille et leur modèle d’affaires,
                toutes les entreprises sont concernées.</p>
                <p>En outre, la crise du Coronavirus montre avec force que le
                niveau de maturité numérique des entreprises impacte de manière
                critique leur capacité à maintenir et développer leurs
                activités.</p>
              </div>
            </div>
            <div class="player-container">
              <iframe src="https://www.youtube.com/embed/8zi3a7AFnIc" title="DigiScore by Digital Wallonia" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <!-- FIN ITERATION 1 -->
        <!-- DEBUT ITERATION 2 -->
        <div class="paragraph__list-item">
          <div class="paragraph-item">
            <div class="paragraph-item__content">
              <div class="paragraph-item__text">
                <!-- ITEM.TEXT -->
                <p><strong>La mesure et l’accélération de cette maturité est donc un enjeu stratégique pour la Wallonie.</strong></p>
                <p>L’Agence du Numérique propose un outil en ligne simple et gratuit pour permettre à toutes les entreprises wallonnes, notamment les PME et TPE, de:</p>
                <ul>
                  <li>Calculer leur DigiScore pour évaluer leur niveau de maturité numérique et le
                  comparer avec celui de leurs concurrents sur base des résultats
                  de 3000 entreprises.</li>
                  <li>Identifier les priorités d’action et les ressources disponibles pour accélérer leur transformation numérique.</li>
              </ul>
              <p>Les entreprises peuvent calculer leur DigiScore seules ou en collaboration avec les acteurs de développement économique qui les accompagnent.</p>
              </div>
              <!-- IF ITEM.BUTTON -->
              <div class="paragraph-item__button">
                <a href="#" class="btn btn-gradient" @click="goToSurvey">J’inscris mon entreprise maintenant</a>
              </div>
            </div>
            <div class="paragraph-item__image">
              <div class="paragraph-item__picture">
                <!-- ITEM.PICTURE -->
                <img srcset="@/assets/images/picture-home-2.jpg 623w,
                  @/assets/images/picture-home-2@2x.jpg 1246w"
                  sizes="(max-width: 480px) 240px,
                  800px"
                  src="@/assets/images/picture-home-2.jpg" />
              </div>
            </div>
          </div>
        </div>
        <!-- FIN ITERATION 2 -->
      <!-- ENDFOREACH; -->
      </div>
    </div>
  </div>
</template>

<script>
import goToSurveyMixin from '@/mixins/goToSurvey';

export default {
  name: 'ParagraphRepeater',
  mixins: [goToSurveyMixin],
};
</script>

<style scoped>
.player-container {
  align-self: center;
  width: 40%;
}

@media (max-width: 46.24em) {
  .player-container {
    width: 100%;
  }
}

.player-container iframe {
  width: 100%;
  min-height: 300px;
}
</style>
